import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router';

import Core                   from "@/core/Core";
import VPassThrough           from '@/lib/components/VPassThrough/VPassThrough.vue';
import MainPage               from '@/pages/common/MainPage/MainPage.vue';
import AppHeaderService from "@/lib/components/AppHeader/AppHeaderService";

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: MainPage,
    meta: {public: true, hideNavbar: true }
  },

  /************************************************* реестры ********************************************************/

  {
    path: '/list/order-positions',
    component: () => import('@/domains/Orders/components/OrderPositionsPage/OrderPositionsPage.vue'),
    props: { adminMode: true },
  },

  {
    path: '/list/preorders',
    component: () => import('@/domains/Preorders/components/PreordersRegistry'),
    props: { adminMode: true },
  },

  {
    path: '/list/tenders',
    component: () => import('@/domains/Tenders/components/TendersRegistry/TendersRegistry.vue'),
    props: { adminMode: true },
  },

  {
    path: '/list/assemblies',
    component: () => import('@/domains/Assemblies/components/AssembliesRegistry/AssembliesRegistry.vue'),
  },

  {
    path: '/list/assemblies-expanded',
    component: () => import('@/domains/Assemblies/components/AssembliesRegistryExpanded/AssembliesRegistryExpanded.vue'),
  },

  {
    path: '/list/shipments',
    component: () => import('@/domains/Shipments/components/ShipmentsRegistry/ShipmentsRegistry.vue'),
  },

  {
    path: '/list/shipments-to-buyer',
    component: () => import('@/domains/ShipmentsToBuyer/components/ShipmentsToBuyerRegistry/ShipmentsToBuyerRegistry.vue'),
  },

  {
    path: '/list/offers',
    component: () => import('@/domains/Offers/components/OffersRegistry/OffersRegistry.vue'),
  },

  /***/

  {
    path: '/list/payments',
    component: () => import('@/domains/PaymentRequests/components/PaymentRequestPage.vue'),
    meta: { role: 'admin', allowedPartnerIds: [67] },
  },

  {
    path: '/list/supply-offers',
    component: () => import('@/domains/SupplyOffers/components/SupplyOffersRegistry/SupplyOffersRegistry'),
    meta: { role: 'buyer' },
  },

  {
    path: '/list/orders',
    component: () => import('@/domains/Orders/components/OrdersRegistryExpanded/OrdersRegistryExpanded.vue'),
    meta: { role: 'buyer' },
  },

  {
    path: '/list/budget-prices',
    component: () => import('@/domains/BudgetPrices/components/BudgetPricesRegistry/BudgetPricesRegistry.vue'),
    meta: { allowedPartnerIds: [67] },
  },

  /***/

  {
    path: '/list/units',
    component: () => import('@/domains/Units/components/UnitsRegistry/UnitsRegistry.vue'),
    meta: { role: 'admin' },
  },

  {
    path: '/list/characteristic-units',
    component: () => import('@/domains/CharacteristicUnits/components/CharacteristicUnitsRegistry/CharacteristicUnitsRegistry.vue'),
    meta: { role: 'admin' },
  },

  {
    path: '/list/transport-zones',
    component: () => import('@/domains/TransportZones/components/TransportZonesRegistry/TransportZonesRegistry.vue'),
    meta: { role: 'admin' },
  },

  {
    path: '/list/transport-orders',
    component: () => import('@/domains/TransportOrders/components/TransportOrdersRegistry/TransportOrdersRegistry.vue'),
    props: { hiddenColumns: ['cargoWeight', 'cargoUnits', 'cargoVolume'] },
    meta: { role: 'admin' },
  },

  {
    path: '/list/product-categories',
    component: () => import('@/domains/ProductCategories/components/ProductCategoriesPage/ProductCategoriesPage.vue'),
    meta: { role: 'admin' },
  },

  {
    path: '/list/leads',
    component: () => import('@/domains/Leads/components/LeadsRegistry/LeadsRegistry.vue'),
    meta: { role: 'admin' },
  },

  {
    path: '/list/demands',
    component: () => import('@/domains/Demand/components/DemandsRegistry/DemandsRegistry.vue'),
  },

  {
    path: '/list/demandsV2',
    component: () => import('@/domains/DemandsV2/components/DemandV2Registry/DemandV2Registry.vue'),
    meta: { role: 'admin' },
  },

  {
    path: '/list/transport-routes',
    component: () => import('@/domains/TransportRoutes/components/TransportRoutesRegistry/TransportRoutesRegistry.vue'),
    meta: { role: 'admin' },
  },

  {
    path: '/list/manufacturers',
    component: () => import('@/domains/Manufacturers/components/ManufacturersRegistry/ManufacturersRegistry.vue'),
    meta: { role: 'admin' },
  },

  {
    path: '/list/production-plans',
    component: () => import('@/domains/ProductionPlans/components/ProductionPlansRegistry/ProductionPlansRegistry.vue'),
    meta: { role: 'admin' },
  },

  {
    path: '/list/receipts',
    component: () => import('@/domains/Receipts/components/ReceiptsRegistry/ReceiptsRegistry.vue'),
  },

  {
    path: '/list/reports',
    component: () => import('@/domains/Reports/components/ReportsList/ReportsList.vue'),
    meta: { role: 'admin' },
  },

  {
    path: '/list/characteristics',
    component: () => import('@/domains/Characteristics/components/CharacteristicsPage.vue'),
    meta: { role: 'admin' },
  },

  {
    path: '/list/packages',
    component: () => import('@/domains/Packages/components/PackagesRegistry/PackagesRegistry.vue'),
    meta: { role: 'admin' },
  },

  {
    path: '/list/changelogs',
    component: () => import('@/core/services/Changelogs/components/ChangelogsRegistry/ChangelogsRegistry.vue'),
    meta: { role: 'admin' },
  },

  {
    path: '/list/stores',
    component: () => import('@/domains/Stores/components/StoresRegistry/StoresRegistry.vue'),
    meta: { role: 'admin' },
  },

  {
    path: '/list/trade-marks',
    component: () => import('@/domains/TradeMarks/components/TradeMarksRegistry/TradeMarksRegistry.vue'),
    meta: { role: 'admin' },
  },

  {
    path: '/list/vehicles',
    component: () => import('@/domains/Vehicles/components/VehiclesPage.vue'),
    meta: { role: 'admin' },
  },

  {
    path: '/list/products',
    component: () => import('@/domains/Products/components/ProductsRegistry/ProductsRegistry.vue'),
    meta: { role: 'buyer' },
  },

  {
    path: '/list/partners',
    component: () => import('@/domains/Partners/components/PartnersRegistry/PartnersRegistry.vue'),
    meta: { role: 'admin' },
  },

  {
    path: '/list/contracts-external',
    component: () => import('@/domains/Contracts/components/ContractsExternalRegistry/ContractsExternalRegistry.vue'),
    meta: { role: 'admin' },
  },

  {
    path: '/list/product-code-mappings',
    component: () => import('@/domains/ProductCodeMappings/components/ProductCodeMappingsRegistry/ProductCodeMappingsRegistry.vue'),
    meta: { role: 'admin' }
  },

  /***/

  {
    path: '/list/contracts-public',
    redirect: '/list/contracts-public/seller',
    meta: { public: true }
  },
  {
    path: '/list/contracts-public/:contractType',
    component: () => import('@/domains/Contracts/components/ContractsPublicPage/ContractsPublicPage.vue'),
    meta: { public: true }
  },
  {
    path: '/list/contracts-public/:contractType/:contractVersion',
    component: () => import('@/domains/Contracts/components/ContractsPublicPage/ContractPublicCard.vue'),
    meta: { public: true }
  },

  /***/

  /************************************************* воронки ********************************************************/

  {
    path: '/flow/orders',
    redirect: '/flow/orders/in-work',
  },
  {
    path: '/flow/orders/:status',
    component: () => import('@/domains/Orders/components/OrdersFlow/OrdersFlow.vue'),
  },

  {
    path: '/flow/preorders',
    redirect: '/flow/preorders/in-work',
  },
  {
    path: '/flow/preorders/:status',
    component: () => import('@/domains/Preorders/components/PreordersFlow.vue'),
  },

  /***/

  {
    path: '/flow/transport-orders',
    component: () => import('@/domains/TransportOrders/components/TransportOrdersPage.vue'),
    meta: { role: 'buyer' },
  },
  {
    path: '/flow/transport-orders/:role(electrostal|lsz|namangan)',
    redirect: to => `${to.path}/in-work`,
  },
  {
    path: '/flow/transport-orders/:role(electrostal|lsz|namangan)/:status(in-work|confirmed|finished)',
    component: () => import('@/domains/TransportOrders/components/TransportOrdersPage.vue'),
    meta: { role: 'buyer' },
  },

  {
    path: '/flow/transportable-docs/:role(electrostal)',
    component: () => import('@/domains/TransportableDocuments/components/TransportableDocumentsPage/TransportableDocumentsPage.vue'),
    meta: { role: 'buyer' },
  },

  {
    path: '/flow/production-plans',
    component: () => import('@/domains/ProductionPlans/components/ProductionPlansRegistry/ProductionPlansRegistry.vue'),
    meta: { role: 'buyer' }
  },

  {
    path: '/flow/tenders',
    component: () => import('@/domains/Tenders/components/TendersFlow/TendersFlow.vue'),
    beforeEnter: ensureDefaultHash('#tenders-tab=active'),
    meta: { auth: true }
  },

  {
    path: '/flow/offers',
    component: () => import('@/domains/Offers/components/OffersFlow/OffersFlow.vue'),
    meta: { auth: true },
    children: [
      { path: '', component: () => import('@/domains/Offers/components/OffersRegistryExpanded/OffersRegistryExpanded.vue') },
      { path: 'all', component: () => import('@/domains/Offers/components/OffersRegistryExpanded/OffersRegistryExpanded.vue'), props: true },
      { path: 'bookmarked', component: () => import('@/domains/Offers/components/OffersRegistryExpanded/OffersRegistryExpanded.vue'),  props: true },
      { path: 'isSamples', component: () => import('@/domains/Offers/components/OffersRegistryExpanded/OffersRegistryExpanded.vue'), props: true },
      { path: 'isNotSamples', component: () => import('@/domains/Offers/components/OffersRegistryExpanded/OffersRegistryExpanded.vue'),  props: true },
      { path: 'my-active', component: () => import('@/domains/Offers/components/OffersRegistryExpanded/OffersRegistryExpanded.vue'),  props: true },
      { path: 'my-inactive', component: () => import('@/domains/Offers/components/OffersRegistryExpanded/OffersRegistryExpanded.vue'),  props: true },

    ],
  },

  /** todo: это тоже своего рода флоу demand -> order (?) надо подумать */

  {
    path: '/demands-page',
    redirect: '/demands-page/new-requests',
  },

  {
    path: '/demands-page/:registry(new-requests|under-review|awaiting-approval|draft)',
    component: () => import('@/domains/DemandsV2/components/DemandsV2Page/DemandsV2Page.vue'),
    meta: { role: 'buyer' },
  },

  /*********************************************** без тулбара ******************************************************/

  {
    path: '/login',
    component: () => import('./pages/common/LoginPage/LoginPage.vue'),
    meta: {public: true, hideNavbar: true},
    children: [
      {path: '', component: () => import('./pages/common/LoginPage/components/LoginView.vue')},
      {path: 'restore', component: () => import('./pages/common/LoginPage/components/RestoreView.vue')},
      {path: 'code', component: () => import('./pages/common/LoginPage/components/CodeView.vue')},
      {path: 'registration', component: () => import('./pages/common/LoginPage/components/RegistrationView.vue')},
    ],
  },

  /************************************************* старое *********************************************************/

  {
    path: '/profile',
    component: VPassThrough,
    meta: {auth: true},
    children: [
      { path: '', redirect: '/profile/companies' },
      { name: 'profile-main',              path: 'main',                      component: () => import('./pages/common/ProfilePage/ProfilePage.vue') },
      { name: 'profile-main-dynamic',      path: 'main/:pathMatch(.*)*',      component: () => import('./pages/common/ProfilePage/ProfilePage.vue') },
      { name: 'profile-company',           path: 'companies',                 component: () => import('./pages/common/ProfilePage/ProfilePage.vue') },
      { name: 'profile-company-dynamic',   path: 'companies/:pathMatch(.*)*', component: () => import('./pages/common/ProfilePage/ProfilePage.vue') },
      { name: 'profile-store',             path: 'stores',                    component: () => import('./pages/common/ProfilePage/ProfilePage.vue') },
      { name: 'profile-store-dynamic',     path: 'stores/:pathMatch(.*)*',    component: () => import('./pages/common/ProfilePage/ProfilePage.vue') },
      { name: 'profile-documents',         path: 'documents',                 component: () => import('./pages/common/ProfilePage/ProfilePage.vue') },
      { name: 'profile-documents-dynamic', path: 'documents/:pathMatch(.*)*', component: () => import('./pages/common/ProfilePage/ProfilePage.vue') },
      { name: 'profile-persons',           path: 'persons',                   component: () => import('./pages/common/ProfilePage/ProfilePage.vue') },
      { name: 'profile-persons-dynamic',   path: 'persons/:pathMatch(.*)*',   component: () => import('./pages/common/ProfilePage/ProfilePage.vue') },
    ],
  },

  // Error pages
  {
    path: '/error',
    component: () => import('./pages/common/ErrorPage/ErrorPage.vue'),
    meta: {public: true},
    props: true,
    children: [
      { path: ':errorNumber', component: () => import('./pages/common/ErrorPage/ErrorPage.vue'), props: true },
    ],
  },

  // Global catch-all redirect
  { path: '/:pathMatch(.*)*', redirect: '/error/404' },
];

const devRoutes = [{
  path: '/lib',
  name: 'LibPage',
  component: () => import('@/lib/pages/MainPage.vue'),
}];

// Использован import.meta.env.DEV вместо Core.config.environment для dev роутов
// т.к. Core недоступен на момент инициализации роутера
if (import.meta.env.DEV) {
  routes.push(...devRoutes);
}

const router = createRouter({
  history: createWebHistory(),
  routes,

  // Настройка скролла
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return {top: 0};
  }
} as any);


// Глобальная проверка авторизации
router.beforeEach((to, from, next) => {
  // Публичные роуты пропускаем
  if (to.meta?.public) {
    next();
    return;
  }

  /** Всё, что не помечено meta.public, требует авторизации.
   * Раньше проверка включалась только при meta.auth или meta.role, а их нет у
   * большинства маршрутов: неавторизованный пользователь проходил на защищённую
   * страницу, компонент читал currentPartner в data и падал на рендере RouterView.
   * Забыть meta.public на публичной странице видно сразу, забыть meta.auth на
   * приватной - нет, поэтому умолчание закрытое */

  /** Если нет авторизации, то идёт на страницу авторизации */
  if (!hasAuth()) {
    next('/login');
    return;
  }

  /** Проверяем доступность для текущего юзера */
  if (to.meta?.role && !hasAccessToPath(to.meta.role, to.meta?.allowedPartnerIds ?? [], to.meta?.mode)) {
    next('/');
    return;
  }

  next();
});

// ========== Вспомогательные функции ==========

/** Проверяет, авторизован ли пользователь в системе */
function hasAuth() {
  return Boolean(Core.currentUser);
}

/** Проверяет, имеет ли текущий партнёр доступ к запрашиваемой роли
 * @param role - роль для проверки ('seller', 'buyer' или 'admin')
 * @returns true, если у партнёра есть соответствующая роль
 */
function hasAccessToPath(role: string, allowedPartnerIds: number[], mode: string): boolean {
  return AppHeaderService.canAccessRoute(role, allowedPartnerIds, mode);
}

// Утилиты для роутера
export function getUserHomePath() {
  //TODO: не уверен, что на профиль это верно, но пусть пока так будет
  if (Core.currentPartner?.isSeller) {
    return '/flow/orders/in-work';
  }

  if (Core.currentPartner?.isBuyer) {
    return '/flow/orders/in-work';
  }

  return '/login';
}

function ensureDefaultHash(defaultHash: string) {
  return (to: any, from: any, next: any) => {
    if (!to.hash) {
      next({ path: to.path, query: to.query, hash: defaultHash, replace: true });
    } else {
      next();
    }
  };
}

export default router;
